import { render, staticRenderFns } from "./ImgItem.vue?vue&type=template&id=31de305d&scoped=true&"
import script from "./ImgItem.vue?vue&type=script&lang=js&"
export * from "./ImgItem.vue?vue&type=script&lang=js&"
import style0 from "./ImgItem.vue?vue&type=style&index=0&id=31de305d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31de305d",
  null
  
)

export default component.exports